module.exports = __webpack_public_path__ + "img/ctrl-c-stub-up--.e72b1161.svg";